export enum FilterContext {
  Company = 1,
  MasterCatalog = 2,
  ProgramCatalog = 4,
  ProjectCatalog = 8
}